import Action from './action';

const initialState = {
    IDNumber: '',
    errorText: '',
};

export default (state = initialState, action: {type: string, playload: string}) => {
    switch (action.type) {
        case Action.UPDATE_ID_NUMBER: {
            return {
                ...state,
                IDNumber: action.playload
            }
        }
        case Action.UPDATE_ID_NUMBER_ERROR_TEXT: {
            try {
                action.playload && (window as any).mailStats.show('IDNumber_error', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorText: action.playload
            }
        }
        default: return state;
    }
}
